import { RMTLocationCategory, RMTMeans, RMTMode } from '../enums/rmt';

export const FREIGHT_TRANS_MODES: RMTMode[] = [
  RMTMode.TRANS_MODE_01,
  RMTMode.TRANS_MODE_02,
  RMTMode.TRANS_MODE_03,
  RMTMode.TRANS_MODE_04,
];
export const PASSENGER_TRANS_MODES: RMTMode[] = [
  RMTMode.TRANS_MODE_05,
  RMTMode.TRANS_MODE_06,
  RMTMode.TRANS_MODE_07,
  RMTMode.TRANS_MODE_08,
  RMTMode.TRANS_MODE_09,
];

export const FREIGHT_TRANS_CAT_MODE_MAPPING: Record<RMTLocationCategory, RMTMode[]> = {
  [RMTLocationCategory.LOCATION_CAT_01]: [RMTMode.TRANS_MODE_02],
  [RMTLocationCategory.LOCATION_CAT_02]: [RMTMode.TRANS_MODE_01, RMTMode.TRANS_MODE_02],
  [RMTLocationCategory.LOCATION_CAT_03]: [RMTMode.TRANS_MODE_02, RMTMode.TRANS_MODE_03],
  [RMTLocationCategory.LOCATION_CAT_04]: [RMTMode.TRANS_MODE_02, RMTMode.TRANS_MODE_04],
  [RMTLocationCategory.LOCATION_CAT_05]: [RMTMode.TRANS_MODE_02],
  [RMTLocationCategory.LOCATION_CAT_06]: [RMTMode.TRANS_MODE_02],
};

export const PASSENGER_TRANS_CAT_MODE_MAPPING: Record<RMTLocationCategory, RMTMode[]> = {
  [RMTLocationCategory.LOCATION_CAT_01]: [RMTMode.TRANS_MODE_06, RMTMode.TRANS_MODE_07],
  [RMTLocationCategory.LOCATION_CAT_02]: [RMTMode.TRANS_MODE_05, RMTMode.TRANS_MODE_06, RMTMode.TRANS_MODE_07],
  [RMTLocationCategory.LOCATION_CAT_03]: [RMTMode.TRANS_MODE_06, RMTMode.TRANS_MODE_07, RMTMode.TRANS_MODE_08],
  [RMTLocationCategory.LOCATION_CAT_04]: [RMTMode.TRANS_MODE_06, RMTMode.TRANS_MODE_07, RMTMode.TRANS_MODE_09],
  [RMTLocationCategory.LOCATION_CAT_05]: [RMTMode.TRANS_MODE_06, RMTMode.TRANS_MODE_07],
  [RMTLocationCategory.LOCATION_CAT_06]: [RMTMode.TRANS_MODE_06],
};

export const RMT_MODE_MEAN_MAPPING: Record<RMTMode, RMTMeans[]> = {
  [RMTMode.TRANS_MODE_01]: [
    RMTMeans.TRANS_MEANS_RAIL_01,
    RMTMeans.TRANS_MEANS_RAIL_02,
    RMTMeans.TRANS_MEANS_RAIL_03,
    RMTMeans.TRANS_MEANS_RAIL_04,
    RMTMeans.TRANS_MEANS_RAIL_05,
    RMTMeans.TRANS_MEANS_RAIL_06,
  ],
  [RMTMode.TRANS_MODE_02]: [
    RMTMeans.TRANS_MEANS_CAR_01,
    RMTMeans.TRANS_MEANS_CAR_02,
    RMTMeans.TRANS_MEANS_CAR_03,
    RMTMeans.TRANS_MEANS_CAR_04,
    RMTMeans.TRANS_MEANS_CAR_05,
    RMTMeans.TRANS_MEANS_CAR_06,
    RMTMeans.TRANS_MEANS_CAR_07,
    RMTMeans.TRANS_MEANS_CAR_08,
    RMTMeans.TRANS_MEANS_CAR_09,
    RMTMeans.TRANS_MEANS_CAR_10,
    RMTMeans.TRANS_MEANS_CAR_11,
    RMTMeans.TRANS_MEANS_CAR_12,
    RMTMeans.TRANS_MEANS_CAR_13,
    RMTMeans.TRANS_MEANS_CAR_14,
    RMTMeans.TRANS_MEANS_CAR_15,
    RMTMeans.TRANS_MEANS_CAR_16,
    RMTMeans.TRANS_MEANS_CAR_17,
    RMTMeans.TRANS_MEANS_CAR_18,
  ],
  [RMTMode.TRANS_MODE_03]: [
    RMTMeans.TRANS_MEANS_SEA_01,
    RMTMeans.TRANS_MEANS_SEA_02,
    RMTMeans.TRANS_MEANS_SEA_03,
    RMTMeans.TRANS_MEANS_SEA_04,
    RMTMeans.TRANS_MEANS_SEA_05,
    RMTMeans.TRANS_MEANS_SEA_06,
    RMTMeans.TRANS_MEANS_SEA_07,
    RMTMeans.TRANS_MEANS_SEA_08,
  ],
  [RMTMode.TRANS_MODE_04]: [RMTMeans.TRANS_MEANS_AIR_01, RMTMeans.TRANS_MEANS_AIR_02, RMTMeans.TRANS_MEANS_AIR_03],
  [RMTMode.TRANS_MODE_05]: [
    RMTMeans.TRANS_MEANS_RAIL_PASS_01,
    RMTMeans.TRANS_MEANS_RAIL_PASS_02,
    RMTMeans.TRANS_MEANS_RAIL_PASS_03,
    RMTMeans.TRANS_MEANS_RAIL_PASS_04,
    RMTMeans.TRANS_MEANS_RAIL_PASS_05,
  ],
  [RMTMode.TRANS_MODE_06]: [
    RMTMeans.TRANS_MEANS_CAR_PASS_01,
    RMTMeans.TRANS_MEANS_CAR_PASS_02,
    RMTMeans.TRANS_MEANS_CAR_PASS_03,
    RMTMeans.TRANS_MEANS_CAR_PASS_04,
    RMTMeans.TRANS_MEANS_CAR_PASS_05,
    RMTMeans.TRANS_MEANS_CAR_PASS_06,
    RMTMeans.TRANS_MEANS_CAR_PASS_07,
    RMTMeans.TRANS_MEANS_CAR_PASS_08,
    RMTMeans.TRANS_MEANS_CAR_PASS_09,
    RMTMeans.TRANS_MEANS_CAR_PASS_10,
  ],
  [RMTMode.TRANS_MODE_07]: [RMTMeans.TRANS_MEANS_OTHER_01],
  [RMTMode.TRANS_MODE_08]: [RMTMeans.TRANS_MEANS_SEA_PASS_01],
  [RMTMode.TRANS_MODE_09]: [RMTMeans.TRANS_MEANS_AIR_PASS_01, RMTMeans.TRANS_MEANS_AIR_PASS_02],
};
